import React from 'react';
import { Link } from 'react-router-dom';

const Unknown = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundImage: 'url(img/vizor-background.png)',
      height: '100%',
      color: 'rgb(255, 255, 255)',
      fontSize: 20,
    }}
  >
    <Link to="/">
      <img
        alt=""
        src="img/vizor-logo-103x122.png"
        height="122"
        width="103"
        style={{ marginRight: 5 }}
      />
    </Link>
    <div>Whoops... No page found</div>
    <div>Click the logo to return to the main page</div>
  </div>
);

export default Unknown;
